// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.phoneverification.RentalManagerUserPhoneVerificationWebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type {
  PhoneVerificationIsVerifiedDto,
  PhoneVerificationSendVerificationCodeDto,
  PhoneVerificationSource,
  PhoneVerificationType,
  PhoneVerificationValidateVerificationCodeDto,
} from '../..';

interface IsVerifiedParams {
  phone: string;
  verificationSource: PhoneVerificationSource;
}
interface SendVerificationCodeParams {
  phone: string;
  verificationSource: PhoneVerificationSource;
  verificationType: PhoneVerificationType;
}
interface ValidateVerificationCodeParams {
  phone: string;
  verificationCode: string;
  verificationSource: PhoneVerificationSource;
}

export const RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Path =
  '/api/web/v1/users/phoneVerification/isVerified';

/**
 * Determine if the phone has been verified for the user
 */
export const RentalManagerUserPhoneVerificationWebApiHandler_isVerified = (
  getParams: IsVerifiedParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<IsVerifiedParams, never, PhoneVerificationIsVerifiedDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPhoneVerificationWebApiHandler_isVerified_Path,
      method: 'GET',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Path =
  '/api/web/v1/users/phoneVerification/sendVerificationCode';

/**
 * Send a verification code to the provided phone
 * @deprecated
 */
export const RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode = (
  getParams: SendVerificationCodeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<SendVerificationCodeParams, never, PhoneVerificationSendVerificationCodeDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPhoneVerificationWebApiHandler_sendVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};

export const RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Path =
  '/api/web/v1/users/phoneVerification/validateVerificationCode';

/**
 * Determine if the verification code is valid for the phone being verified
 * @deprecated
 */
export const RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode = (
  getParams: ValidateVerificationCodeParams,
  client = getClient(),
) => {
  return httpFrontEndRequest<ValidateVerificationCodeParams, never, PhoneVerificationValidateVerificationCodeDto>(
    {
      getParams: getParams,
      endpoint: RentalManagerUserPhoneVerificationWebApiHandler_validateVerificationCode_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
    },
    client,
  );
};
